import { reactive } from 'vue';
import axios from 'axios';
import useProduct from '@/stores/Product';
import useTransport from '@/stores/Transport';

const httpInstance = axios.create();

const state = reactive({
  bonusCode: null,
  isValid: false
});

export default function useBonusCode() {
  const getBonusCode = () => {
    return state.bonusCode;
  };

  const updateBonusCode = async code => {
    if (!code) {
      return false;
    }
    try {
      const {
        data: { items, transport, success }
      } = await httpInstance.post('get/api/shopBasket/setBonusCode', {
        code
      });

      state.bonusCode = code;
      state.isValid = success;

      const { setProducts } = useProduct();
      setProducts(items || []);

      const { setTransport } = useTransport();
      setTransport(transport || []);
    } catch (error) {
      console.error(error);
    }
  };

  const removeBonusCode = async () => {
    try {
      const {
        data: { items, transport }
      } = await httpInstance.post('get/api/shopBasket/removeBonusCode');

      state.bonusCode = null;
      state.isValid = false;

      const { setProducts } = useProduct();
      setProducts(items || []);

      const { setTransport } = useTransport();
      setTransport(transport || []);
    } catch (error) {
      console.error(error);
    }
  };

  const setBonusCode = code => {
    state.bonusCode = code;
    state.isValid = true;
  };

  const isBonusCodeValid = () => {
    return !!state.isValid;
  };

  return {
    getBonusCode,
    updateBonusCode,
    removeBonusCode,
    setBonusCode,
    isBonusCodeValid
  };
}
